<mat-expansion-panel hideToggle expanded=true *ngIf="showTerminos">
    <mat-expansion-panel-header>
        <mat-panel-title>
            Aceptar términos y condiciones
        </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="row-contratacion">
        <p class="txt-contratacion">Para <b>continuar con esta contratación</b> necesitas que tú y todas las personas autorizadas en la escritura o con poder notarial, acepten los términos y condiciones.</p>
        <p class="txt-documentos">Documentos:</p>
        <div class="d-flex">
            <p class="txt-solicitud">- Solicitud de afiliación </p>
            <p class="txt-prvisualizar" (click)="preview()" *ngIf="!loaginPDF"> previsualizar</p>
            <span class="txt-solicitud font-weight-bold" *ngIf="loaginPDF">Espere un momento...</span>
        </div>
    </div>
    <ng-container *ngIf="!debeAceptarTerminos && loading">
        <div *ngIf="loading" class="spinner-border text-light" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </ng-container>

    <!-- PJ -->
    <ng-container *ngIf="!isPersonaNatural && listSignersView.length > 0">
        <div class="row-resumen">
            <div class="row" *ngFor="let firmante of listSignersView">
                <div class="col-md-8">
                    <p class="txt-nombre"> A nombre de: <b>{{ firmante.nombre}}</b>, <b>RUT {{ firmante.rut | formatrut }}, </b>
                        Nacionalidad <b>{{ firmante.nacionalidad }}</b></p>
                </div>
                <div class="col-md-4 d-flex justify-content-end">
                    <img src="assets/icons/icon-check.svg" alt="checkFirma" *ngIf="firmante.estado === 'APROBADO' ">
                    <div *ngIf="firmante.estado === 'SIN_APROBAR' ">
                        <button class="btn-secondary-tbk" type="button" (click)='aceptarDocumentoRRLL(firmante.rut)' [disabled]="firmarDoc">
                            <div class="spinner-border text-light" id="loadingBtnFirm" *ngIf='firmarDoc' role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            <span *ngIf="!firmarDoc && firmante.estado === 'SIN_APROBAR'">
                                Aceptar
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <hr>
    </ng-container>
    <!-- fin PJ -->

    <!-- PN -->
    <mat-checkbox *ngIf="isPersonaNatural" [(ngModel)]="isAceptaTerminos" class="d-flex align-items-center mt-4"><b> Acepto los términos y condiciones del contrato</b></mat-checkbox>
    <ng-container *ngIf="isPersonaNatural && !debeAceptarTerminos && isFirmado">
        <div class="row-nombre">
            <div>
                <p class="txt-nombre">Documento: <b>{{anexosAceptar.data.tituloDocumento}}</b> firmado.</p>
            </div>
        </div>
    </ng-container>
    <!-- fin PN -->

</mat-expansion-panel>

<div class="row" *ngIf="showTerminos && isPersonaNatural">
    <div class="col-md-12">
        <button class="btn-primary-tbk" type="submit" value="Continuar" [disabled]="!isAceptaTerminos" (click)="continuarPaso3()">
            <div *ngIf="loadingButton" class="spinner-border text-light" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div *ngIf="!loadingButton">Continuar</div>    
        </button>
    </div>
</div>

<div class="row" *ngIf="showTerminos && !isPersonaNatural">
    <div class="col-md-12">
        <button class="btn-primary-tbk" type="submit" value="Continuar" [disabled]="!isAceptaTerminos" (click)="continuarPaso3()">
            <div *ngIf="loadingButton" class="spinner-border text-light" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <div *ngIf="!loadingButton">Continuar</div>    
        </button>
    </div>
</div>